import actionTypes from 'constants/actionTypes'
import { initiateConfirmation } from 'actions/confirm'
import * as selectConfirmModule from 'selectors/confirm'
import type { MiddlewareStoreShape, NextFn } from 'types/adapters'


type ConfirmAction = {
  type?: string
  payload?: {
    idx?: number
  }
  meta?: {
    confirm?: (state: unknown) => string | null | undefined
    [key: string]: unknown
  }
  [key: string]: unknown
}

type ConfirmState = {
  toConfirm: Array<{
    action?: unknown
  }>
}

type MiddlewareStore = MiddlewareStoreShape

const selectConfirm = selectConfirmModule.default || selectConfirmModule

const selectConfirmState = (state: unknown): ConfirmState => {
  if (typeof selectConfirm !== 'function') {
    return { toConfirm: [] }
  }
  const result = selectConfirm(state as Record<string, unknown>) as unknown
  if (result == null || typeof result !== 'object') {
    return { toConfirm: [] }
  }
  const toConfirm = (result as { toConfirm?: unknown }).toConfirm
  return { toConfirm: Array.isArray(toConfirm) ? toConfirm : [] }
}

const captureConfirm = (store: MiddlewareStore) => (next: NextFn<ConfirmAction>) => (action: ConfirmAction) => {
  const message = action.meta?.confirm?.(store.getState())
  if (message == null) {
    return next(action)
  }
  if (action.meta) {
    delete action.meta.confirm
  }
  store.dispatch(initiateConfirmation({ message, action }))
}

const releaseConfirm = (store: MiddlewareStore) => (next: NextFn<ConfirmAction>) => (action: ConfirmAction) => {
  if (action.type !== actionTypes.CONFIRM.CONFIRM) {
    return next(action)
  }
  const { toConfirm } = selectConfirmState(store.getState())
  const confirmAction = toConfirm[action.payload?.idx || 0]?.action
  if (confirmAction) {
    store.dispatch(confirmAction)
  }
  return next(action)
}

export { captureConfirm, releaseConfirm }
